import { GET_REPORT_TITLES, GET_FEED, DELETE_ACTIVITY } from "./types";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import moment from "moment";

export const deleteActivity = (ref) => {
    let newYear = moment().format("YYYY");
    let newMonth = moment().format("MMM").toLowerCase();
    return (dispatch) => {
        dispatch({ type: DELETE_ACTIVITY.REQUEST });
        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user === null) {
                    dispatch({ type: DELETE_ACTIVITY.FAIL });
                }
                firebase
                    .database()
                    .ref(`/subjects/activity_log/${newYear}/${newMonth}`)
                    .child(`${ref}`)
                    .remove();
            });
        } catch (e) {
            dispatch({ type: DELETE_ACTIVITY.FAIL });
        }
    };
};

export const getReportTitles = () => {
    return (dispatch) => {
        dispatch({ type: GET_REPORT_TITLES.REQUEST });

        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user === null) {
                    dispatch({ type: GET_REPORT_TITLES.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/collections/report_titles")
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_REPORT_TITLES.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_REPORT_TITLES.FAIL });
        }
    };
};
export const getActivities = (limit = false) => {
    return (dispatch) => {
        dispatch({ type: GET_FEED.REQUEST });
        let newYear = moment().format("YYYY");
        let newMonth = moment().format("MMM").toLowerCase();
        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user === null) {
                    dispatch({ type: GET_FEED.FAIL });
                } else {
                    let ref;

                    if (limit === false)
                        ref = firebase
                            .database()
                            .ref(
                                `/subjects/activity_log/${newYear}/${newMonth}`
                            );
                    else
                        ref = firebase
                            .database()
                            .ref(
                                `/subjects/activity_log/${newYear}/${newMonth}`
                            )
                            .limitToLast(limit);

                    ref.on("value", (snapshot) => {
                        dispatch({
                            type: GET_FEED.SUCCESS,
                            payload: snapshot.val(),
                        });
                    });
                }
            });
        } catch (e) {
            dispatch({ type: GET_FEED.FAIL });
        }
    };
};
export const getCurrUserName = async () => {
    let user = await firebase.auth().onAuthStateChanged((user) => {
        return user;
    });

    if (user) {
        let snapshot = await firebase
            .database()
            .ref(`/users/${user.user.uid}/profile`)
            .once("value");

        let profile = snapshot.val();
        return profile.first_name + " " + profile.last_name;
    } else {
        return false;
    }
};
export const setActivity = (operation, subject_child, subject_name) => {
    
    return (dispatch) => {
        dispatch({ type: GET_FEED.REQUEST });
        let newYear = moment().format("YYYY");
        let newMonth = moment().format("MMM").toLowerCase();
        let timestamp = moment().format("DD-MM-YYYY HH:mm:ss");
        let id = Date.now().toString();
        try {
            firebase.auth().onAuthStateChanged(async (user) => {
                if (user === null) {
                   
                    dispatch({ type: GET_FEED.FAIL });      
                } else {
                    
                    let snapshot = await firebase
                        .database()
                        .ref(`/users/${user.uid}/profile`)      
                        .once("value");

                    let profile = snapshot.val();

                    let user_name =
                        profile.first_name + " " + profile.last_name;
                    let activity = {
                        operation,
                        subject_child,
                        subject_name,
                        user_name,
                        timestamp,
                        platform: "dashboard",
                    };
                    firebase
                        .database()
                        .ref(`/subjects/activity_log/${newYear}/${newMonth}`)
                        .update({ [id]: activity });
                }
            });
        } catch (e) {
            dispatch({ type: GET_FEED.FAIL });
        }
    };
};
